import GlobalNavLink from "../components/parts/navlinks/GlobalNavLink";
import HeaderShadowSeparator from "../components/parts/separator/HeaderShadowSeparator";
import SignAndLogForm from "../components/signAndLog/SignAndLogForm";
import SigninWith from "../components/signAndLog/SigninWith";

const SignAndLogPage = ({ type = "log" }) => {

    const dashCss = 'w-full h-0.5 bg-darkRed'
    const leftDashCss = `${dashCss} justify-start`
    const rightDashCss = `${dashCss} justify-end`

    const txt = type === "log" ? ["Connexion", "Pas encore inscrit ?", "/signup", "Ou bien connecte-toi avec :"] : ["Inscription", "Déjà inscrit ?", "/login", "Ou bien inscris-toi avec :"]

    return (
        <main className="relative w-full main-disconnected bg-cover bg-giftImg flexJustifyItemsCenter flex-col">
            <HeaderShadowSeparator css="bg-ivory" />
            <div className="w-full global-px py-6 bg-white sm:rounded-xl sm:my-12 sm:w-1/2 xl:w-1/3">
                <h1 className="text-darkRed text-center mb-4 text-4xl font-bold">{txt[0]}</h1>
                <span className="flexJustifyItemsCenter w-full text-darkOrange text-center">{txt[1]}&nbsp;
                    <GlobalNavLink
                        type="landingPageBtn"
                        to={txt[2]}
                        txt="C'est ici"
                        css="font-semibold underline cursor-pointer"
                    />
                </span>
                <SignAndLogForm type={type} />
                <div className="flex justify-between items-center w-full">
                    <i className={leftDashCss} />
                    <span className="w-full px-4 text-center text-darkRed whitespace-nowrap">{txt[3]}</span>
                    <i className={rightDashCss} />
                </div>
                <div className="w-full mt-6 flex justify-around items-center">
                    <SigninWith withWhat='google' />
                    <SigninWith withWhat='facebook' />
                </div>
                {
                    type === "sign" && <>
                        <p className="mt-6 text-darkRed text-justify leading-6">
                            En créant un compte, j'accepte les&nbsp;
                            <GlobalNavLink
                                type="landingPageBtn"
                                to="/"
                                txt="Termes et conditions"
                                css="font-semibold text-darkOrange cursor-pointer"
                            />
                            &nbsp;ainsi que la&nbsp;
                            <GlobalNavLink
                                type="landingPageBtn"
                                to="/dataProtectionDisconnected"
                                txt="Politique de Confidentialité"
                                css="font-semibold text-darkOrange cursor-pointer"
                            />
                            &nbsp;du site.
                        </p>
                    </>
                }
            </div>
        </main>
    );
};

export default SignAndLogPage;